import Icon from "hardcover-ui/components/Icon";
import LoadingSpinner from "hardcover-ui/components/LoadingSpinner";
import shareIcon from "icons/duotone/up-from-bracket.svg";

export default function ShareButton({
  onClick,
  loading = false,
}: {
  onClick?: () => void;
  loading?: boolean;
}) {
  return (
    <button
      aria-label="Copy Link"
      type="button"
      className="text-foreground hover:text-accent transition-colors"
      onClick={onClick}
    >
      {loading ? (
        <LoadingSpinner size="md" />
      ) : (
        <Icon icon={shareIcon} size="xl" />
      )}
    </button>
  );
}
